module.exports = __webpack_public_path__ + "media/tycho2t3_80_mx.aa1788b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/sky_box/tycho2t3_80_mx.jpg
// module id = 1090
// module chunks = 0